var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoBan = function SvgVideoBan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.31 9.063a1.363 1.363 0 0 0-1.388 0l-3.155 2.284v-.882A3.47 3.47 0 0 0 17.3 7H5.465A3.466 3.466 0 0 0 2 10.465v7.832a3.466 3.466 0 0 0 3.465 3.465h7.1a6.953 6.953 0 0 1-.472-1.618H5.465a1.851 1.851 0 0 1-1.847-1.847v-7.832c0-1.017.825-1.843 1.847-1.847h11.831c1.018 0 1.843.825 1.848 1.847v1.537c.91.018 1.778.21 2.571.544l2.667-1.879v3.857a6.97 6.97 0 0 1 1.61 4.126c.005-.05.008-.1.008-.152v-8.23a1.365 1.365 0 0 0-.69-1.205Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.795 16.44H6.919a.9.9 0 0 0 0 1.8h1.876a.9.9 0 0 0 0-1.8ZM15.852 10.84a.806.806 0 1 1 1.613 0 .806.806 0 0 1-1.613 0Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 19a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-1.7 0a4.3 4.3 0 0 1-7.175 3.198l6.669-5.224A4.28 4.28 0 0 1 23.3 19Zm-8.19 1.834 6.601-5.172a4.3 4.3 0 0 0-6.601 5.172Z",
    fill: "#fff"
  })));
};
export default SvgVideoBan;